import { createSelector } from 'reselect';
import { LoadStatus, State, User } from '../../Types';
import { UsersState } from './Types/UsersState';

const userState = ({ users: usersState }: State) => usersState;

// Load Status
export const usersLoadStatus = createSelector(userState, (usersState: UsersState) => usersState.loadStatus);

export const usersAreLoaded = createSelector(usersLoadStatus, (loadStatus: LoadStatus) => loadStatus === LoadStatus.LOADED);

// Users
export const users = createSelector(userState, (state: UsersState) => state.users);

export const userById = (userId: number | string) =>
    createSelector(users, (users: { [userId: number]: User }) => users[userId] || {});

// User Search
export const usersSearchList = createSelector(userState, (state: UsersState) => state.usersSearchList);